import { setupLazyLoad } from './lazy-load';
import { setupMenu } from './menu';
import { setupToggles } from './toggles';
import { setupProductCarousel, setupHomeSlideshow, setupSlideshow, setupPhotoGallery } from './sliders';

export function setup($: JQueryStatic) {
  setupToggles();
  setupLazyLoad();
  setupMenu($);
  setupProductCarousel($);
  setupHomeSlideshow($);
  setupSlideshow($);
  setupPhotoGallery($);
}
